module.exports = __webpack_public_path__ + "static/media/play-score-4.b4b51fa0.png";